module.exports = __webpack_public_path__ + "assets/appstore-badge.68655d98.svg";